import {txt, type Texto} from '../i18n/idioma';

// Nota de cada campo de Inventario → Mineros (Daniel, 14/10/2026): qué es y
// cómo se llena. La usan las columnas de la tabla (al pasar el cursor por el
// título), los filtros, la línea de etapas, el corte mensual y las cargas.
// "Archivo de la planta" = BD Envíos Mineros Aluvial; "base de la bodega" = el
// libro de Big Bags de exportación de la bodega de Cartagena.
export const AYUDA_MINEROS: Record<string, Texto> = {
  // ── Columnas de la tabla ──
  bbNo: txt(
    'Número del Big Bag de Mineros. Sale de la columna # BIG BAG de la hoja EMPAQUE del BD Envíos Mineros Aluvial; la app unifica los nombres: bajo tenor queda VLG-<número> y alto tenor MABBHG<4 dígitos>.',
    'Mineros Big Bag number. It comes from the # BIG BAG column of the EMPAQUE sheet in BD Envíos Mineros Aluvial; the app standardizes the names: low grade becomes VLG-<number> and high grade MABBHG<4 digits>.',
  ),
  tenor: txt(
    'Alto tenor (MABBHG) o bajo tenor (VLG). Lo decide el nombre del Big Bag en el archivo de la planta: BBHG es alto y VLG es bajo.',
    'High grade (MABBHG) or low grade (VLG). The Big Bag name in the plant file decides it: BBHG is high and VLG is low.',
  ),
  etapa: txt(
    'Dónde estaba el Big Bag en la fecha de corte. La calcula la app con sus fechas: salida de El Bagre = Camino; ingreso a la bodega o fecha de la TM = Bodega; llenado del contenedor = En puerto; zarpe = Navegando; después, la llegada y el estado del seguimiento. Antes del puerto dice si estaba asignado a una exportación o disponible.',
    'Where the Big Bag was on the cut-off date. The app works it out from its dates: left El Bagre = On the way; entered the warehouse or TM date = Warehouse; container filled = In port; departure = At sea; then the arrival and the tracking status. Before the port it says whether it was assigned to an export or available.',
  ),
  exportacion: txt(
    'Exportación de Mineros (MA0XX) a la que va el Big Bag. Sale de la lista de empaque de la exportación (Calculos Expo concentrados MA0XX, hoja International PL Bags, o Expo MA0XX); si no está en ninguna lista, conserva la que ya tenía en la app.',
    'Mineros export (MA0XX) the Big Bag belongs to. It comes from the export packing list (Calculos Expo concentrados MA0XX, International PL Bags sheet, or Expo MA0XX); if it is in no list, it keeps the one it already had in the app.',
  ),
  contenedor: txt(
    'Contenedor en que se llenó. Sale de la columna NO CONTENEDOR EXP de la base de la bodega de Cartagena (hojas BD Big bags o BD Tulas).',
    'Container it was filled into. It comes from the NO CONTENEDOR EXP column of the Cartagena warehouse database (BD Big bags or BD Tulas sheets).',
  ),
  tm: txt(
    'Recolección (TM) con que el Big Bag viajó de El Bagre a Cartagena. Sale de la declaración de valor en PDF (el número va en el nombre del archivo). Si aparece en dos declaraciones, queda la que dice la columna RECOLECCIÓN de la base de la bodega; si no lo dice, la de número menor.',
    'Pickup (TM) the Big Bag travelled with from El Bagre to Cartagena. It comes from the value declaration PDF (the number is in the file name). If it appears in two declarations, the one in the RECOLECCIÓN column of the warehouse database wins; otherwise the lower number.',
  ),
  lotes: txt(
    'Lotes con datos sobre lotes del Big Bag, contados por la app en las hojas EMPAQUE y Bolsas por Lote. Un lote tiene datos si trae pesos húmedo y seco, tenores y gramos de oro y plata. Con ⚠ falta alguno y el Big Bag no suma pesos ni metales.',
    'Lots with data out of the Big Bag’s lots, counted by the app in the EMPAQUE and Bolsas por Lote sheets. A lot has data when it has wet and dry weights, grades and gold and silver grams. With ⚠ one is missing and the Big Bag adds no weights or metals.',
  ),
  sello: txt(
    'Sello de planta del Big Bag. Sale de la columna SELLO de la hoja EMPAQUE; si sus lotes traen sellos distintos, se muestran todos.',
    'Plant seal of the Big Bag. It comes from the SELLO column of the EMPAQUE sheet; if its lots have different seals, all are shown.',
  ),
  envio: txt(
    'Envío (remesa) de la planta en que salió. Sale de la columna ENVÍO de la hoja EMPAQUE.',
    'Plant shipment (consignment) it left in. It comes from the ENVÍO column of the EMPAQUE sheet.',
  ),
  codigosDeLotes: txt(
    'Códigos de los lotes de la planta que forman el Big Bag. Salen de la columna LOTE de la hoja EMPAQUE.',
    'Codes of the plant lots that make up the Big Bag. They come from the LOTE column of the EMPAQUE sheet.',
  ),
  movimiento: txt(
    'Cómo llegó a Cartagena: terrestre, si la base de la bodega lo registra como Big Bag completo (hoja BD Big bags), o aéreo, si registra sus tulas sueltas (hoja BD Tulas). Lo decide la app.',
    'How it reached Cartagena: by land, if the warehouse database records it as a whole Big Bag (BD Big bags sheet), or by air, if it records its loose sacks (BD Tulas sheet). The app decides it.',
  ),
  salidaPlanta: txt(
    'Fecha en que salió de la planta de El Bagre. Sale de la columna FECHA ENVÍO de la hoja EMPAQUE; si tiene varios lotes, la más reciente.',
    'Date it left the El Bagre plant. It comes from the FECHA ENVÍO column of the EMPAQUE sheet; with several lots, the latest one.',
  ),
  fechaTm: txt(
    'Fecha de la declaración de valor (TM) con que viajó, leída del PDF. Desde ese día el Big Bag cuenta en la bodega de Cartagena.',
    'Date of the value declaration (TM) it travelled with, read from the PDF. From that day the Big Bag counts in the Cartagena warehouse.',
  ),
  cargue: txt(
    'Fecha en que se cargó el camión hacia Cartagena. Sale de la columna FECHA CARGUE de la hoja BD Big bags de la base de la bodega (solo los terrestres).',
    'Date the truck to Cartagena was loaded. It comes from the FECHA CARGUE column of the BD Big bags sheet in the warehouse database (land shipments only).',
  ),
  ingresoCartagena: txt(
    'Fecha en que entró a la bodega de Cartagena. Sale de la columna FECHA DESCARGUE de la base de la bodega; en los aéreos, la de su última tula.',
    'Date it entered the Cartagena warehouse. It comes from the FECHA DESCARGUE column of the warehouse database; for air shipments, that of its last sack.',
  ),
  tulas: txt(
    'Tulas recibidas en la bodega sobre las tulas que mandó la planta. Las esperadas salen de la hoja Bolsas por Lote; las recibidas, de la hoja BD Tulas de la base de la bodega (un terrestre descargado las tiene todas).',
    'Sacks received at the warehouse out of the sacks the plant sent. The expected ones come from the Bolsas por Lote sheet; the received ones, from the BD Tulas sheet of the warehouse database (an unloaded land shipment has them all).',
  ),
  salidaBodega: txt(
    'Fecha en que se llenó el contenedor y salió de la bodega; desde ahí cuenta como exportado. Sale de la columna FECHA LLENADO de la base de la bodega; en los aéreos, la de su última tula.',
    'Date the container was filled and it left the warehouse; from then on it counts as exported. It comes from the FECHA LLENADO column of the warehouse database; for air shipments, that of its last sack.',
  ),
  etd: txt(
    'Zarpe de su exportación: la salida real si ya la hay; si no, el ETD. Sale del seguimiento de exportaciones.',
    'Departure of its export: the actual departure if there is one; otherwise the ETD. It comes from the export tracking.',
  ),
  eta: txt(
    'Llegada estimada (ETA) de su exportación. Sale del seguimiento de exportaciones.',
    'Estimated arrival (ETA) of its export. It comes from the export tracking.',
  ),
  tonHumedas: txt(
    'Toneladas húmedas: suma del peso húmedo de sus lotes en la hoja EMPAQUE. Con lotes sin datos queda en —.',
    'Wet tons: sum of the wet weight of its lots in the EMPAQUE sheet. With lots missing data it shows —.',
  ),
  tonSecas: txt(
    'Toneladas secas: suma del peso seco de sus lotes en la hoja EMPAQUE; si el seco es mayor que el húmedo, se toma el húmedo. Con lotes sin datos queda en —.',
    'Dry tons: sum of the dry weight of its lots in the EMPAQUE sheet; if dry is greater than wet, wet is used. With lots missing data it shows —.',
  ),
  auG: txt(
    'Gramos de oro: suma de PESO ORO de sus lotes en la hoja EMPAQUE. Manda sobre el documento de exportación; en amarillo si no coinciden.',
    'Gold grams: sum of PESO ORO of its lots in the EMPAQUE sheet. It prevails over the export document; yellow if they do not match.',
  ),
  auGDocumento: txt(
    'Gramos de oro según el documento de exportación (columna Au gr de la hoja International PL Bags, o Peso Oro (g) de Expo MA0XX). Solo para comparar: manda la base de la planta.',
    'Gold grams according to the export document (Au gr column of the International PL Bags sheet, or Peso Oro (g) in Expo MA0XX). Only for comparison: the plant data prevails.',
  ),
  auGt: txt(
    'Tenor de oro en gramos por tonelada seca. Lo calcula la app: gramos de oro ÷ toneladas secas.',
    'Gold grade in grams per dry ton. The app works it out: gold grams ÷ dry tons.',
  ),
  auOz: txt(
    'Onzas troy de oro. Lo calcula la app: gramos de oro ÷ 31,1035.',
    'Troy ounces of gold. The app works it out: gold grams ÷ 31.1035.',
  ),
  agG: txt(
    'Gramos de plata: suma de PESO PLATA de sus lotes en la hoja EMPAQUE.',
    'Silver grams: sum of PESO PLATA of its lots in the EMPAQUE sheet.',
  ),
  agOz: txt(
    'Onzas troy de plata. Lo calcula la app: gramos de plata ÷ 31,1035.',
    'Troy ounces of silver. The app works it out: silver grams ÷ 31.1035.',
  ),
  valorDeclaradoUsd: txt(
    'Valor en USD del Big Bag en su declaración de valor (TM), leído del PDF.',
    'USD value of the Big Bag in its value declaration (TM), read from the PDF.',
  ),
  novedades: txt(
    'Lo que hay que revisar del Big Bag (tulas faltantes, sellos que no cuadran, oro distinto al documento, lotes sin datos…). Lo anota la app en cada carga de archivos y se quita cuando una carga nueva ya no lo encuentra; al pasar el cursor se ve el detalle.',
    'What needs checking on the Big Bag (missing sacks, seals that do not match, gold differing from the document, lots missing data…). The app notes it on each file load and it goes away when a new load no longer finds it; hover to see the detail.',
  ),

  // ── Filtros ──
  corte: txt(
    'Día en que se mira el inventario: etapas, asignación y cifras se calculan con las fechas que tenía cada Big Bag hasta ese día. Vacío = hoy; los botones eligen hoy o el cierre de un mes.',
    'Day the inventory is viewed on: stages, assignment and figures are worked out from the dates each Big Bag had up to that day. Empty = today; the buttons pick today or a month end.',
  ),
  filtroTenor: txt(
    'Muestra solo alto tenor (MABBHG), solo bajo tenor (VLG) o todos. Lo decide el nombre del Big Bag en el archivo de la planta.',
    'Shows only high grade (MABBHG), only low grade (VLG) or all. The Big Bag name in the plant file decides it.',
  ),
  filtroAsignacion: txt(
    'En la bodega: disponibles (sin exportación en la fecha de corte) o asignados a una exportación. En un corte pasado, un Big Bag cuenta como asignado desde que su exportación empezó a llenar contenedores.',
    'In the warehouse: available (no export on the cut-off date) or assigned to an export. On a past cut-off, a Big Bag counts as assigned from the day its export started filling containers.',
  ),
  buscar: txt(
    'Busca por BB #, sello, contenedor, códigos de lotes, envío de planta o exportación. Basta con una parte del texto.',
    'Searches by BB #, seal, container, lot codes, plant shipment or export. Part of the text is enough.',
  ),
  filtroExportacion: txt(
    'Exportación de Mineros del Big Bag, según las listas de empaque. "Sin exportación" = los que no tienen. Se pueden elegir varias.',
    'Mineros export of the Big Bag, according to the packing lists. "No export" = those without one. You can choose several.',
  ),
  filtroTm: txt(
    'Recolección (TM) de la declaración de valor con que viajó. "Sin declaración de valor" = los que aún no aparecen en ninguna.',
    'Pickup (TM) of the value declaration it travelled with. "No value declaration" = those not yet in any.',
  ),
  filtroNovedad: txt(
    'Tipo de novedad que anotó la app al cargar los archivos. Se pueden elegir varios.',
    'Type of issue the app noted when loading the files. You can choose several.',
  ),
  filtroZarpe: txt(
    'Mes de zarpe de su exportación (la salida real o, si no la hay, el ETD), tomado del seguimiento de exportaciones.',
    'Departure month of its export (the actual departure or, if none, the ETD), taken from the export tracking.',
  ),
  filtroLlegada: txt(
    'Llegada estimada (ETA) de su exportación, tomada del seguimiento de exportaciones.',
    'Estimated arrival (ETA) of its export, taken from the export tracking.',
  ),
  soloNovedades: txt(
    'Solo los Big Bags con alguna novedad anotada en la última carga de archivos.',
    'Only the Big Bags with an issue noted in the latest file load.',
  ),
  filtroOroDistinto: txt(
    'Solo los Big Bags cuyo oro en la base de la planta difiere en más de 0,05 g del documento de exportación.',
    'Only the Big Bags whose gold in the plant data differs by more than 0.05 g from the export document.',
  ),

  // ── Resumen y etapas ──
  archivos: txt(
    'Archivos de la última carga y hasta dónde llegan: el último despacho de la hoja EMPAQUE (salida de El Bagre) y el último ingreso o llenado de la base de la bodega.',
    'Files from the latest load and how far they go: the last shipment in the EMPAQUE sheet (left El Bagre) and the last entry or filling in the warehouse database.',
  ),
  etapas: txt(
    'Big Bags en cada etapa en la fecha de corte; juntas suman el total. La app las calcula con las fechas de cada Big Bag (salida de El Bagre, ingreso o TM en la bodega, llenado del contenedor, zarpe, llegada) y el estado del seguimiento. "disp." = sin exportación; "asig." = asignados.',
    'Big Bags in each stage on the cut-off date; together they add up to the total. The app works them out from each Big Bag’s dates (left El Bagre, warehouse entry or TM, container filling, departure, arrival) and the tracking status. "avail." = no export; "assig." = assigned.',
  ),
  disponible: txt(
    'Big Bags en la planta, en camino o en la bodega sin exportación asignada en la fecha de corte. Toneladas secas y onzas solo de los que tienen todos sus lotes con datos.',
    'Big Bags at the plant, on the way or in the warehouse with no export assigned on the cut-off date. Dry tons and ounces only from those with all their lots with data.',
  ),
  novedadesResumen: txt(
    'Cuántos Big Bags tienen cada tipo de novedad, anotada por la app en la carga de archivos. Clic en uno filtra la tabla; al pasar el cursor dice qué hacer.',
    'How many Big Bags have each type of issue, noted by the app when loading the files. Click one to filter the table; hover to see what to do.',
  ),

  // ── Por mes ──
  mes: txt(
    'Mes del calendario, desde el primer despacho de la planta hasta el mes de la fecha de corte.',
    'Calendar month, from the first plant shipment to the month of the cut-off date.',
  ),
  despachado: txt(
    'Big Bags y onzas de oro que salieron de El Bagre en el mes (fecha de envío de la hoja EMPAQUE).',
    'Big Bags and gold ounces that left El Bagre in the month (shipment date in the EMPAQUE sheet).',
  ),
  ingresado: txt(
    'Big Bags y onzas que entraron a la bodega de Cartagena en el mes (fecha de descargue de la base de la bodega).',
    'Big Bags and ounces that entered the Cartagena warehouse in the month (unloading date in the warehouse database).',
  ),
  llenado: txt(
    'Big Bags con exportación cuyo contenedor se llenó en el mes (fecha de llenado de la base de la bodega): ahí pasan a exportados.',
    'Big Bags with an export whose container was filled in the month (filling date in the warehouse database): that is when they become exported.',
  ),
  enPlantaOCamino: txt(
    'Lo que el último día del mes seguía en la planta o en camino a Cartagena, según la etapa calculada a esa fecha.',
    'What was still at the plant or on the way to Cartagena on the last day of the month, by the stage worked out for that date.',
  ),
  enBodega: txt(
    'Lo que el último día del mes estaba en la bodega de Cartagena; entre paréntesis, cuántos ya estaban asignados a una exportación.',
    'What was in the Cartagena warehouse on the last day of the month; in brackets, how many were already assigned to an export.',
  ),

  // ── Cargas de archivos ──
  archivoEnvios: txt(
    'Archivo de la planta, el de número más alto. Se leen las hojas EMPAQUE (lotes con pesos, tenores y gramos), Bolsas por Lote (tulas) y Draga_municipio; todo Big Bag que esté aquí entra al inventario.',
    'Plant file, the one with the highest number. The EMPAQUE (lots with weights, grades and grams), Bolsas por Lote (sacks) and Draga_municipio sheets are read; every Big Bag in it enters the inventory.',
  ),
  archivoBodega: txt(
    'Base de la bodega de Cartagena. De las hojas BD Big bags y BD Tulas solo se leen fechas, pesos, precintos, contenedores y la recolección; nunca datos de personas.',
    'Cartagena warehouse database. From the BD Big bags and BD Tulas sheets only dates, weights, seals, containers and the pickup are read; never personal data.',
  ),
  archivoListas: txt(
    'Listas de empaque: Calculos Expo concentrados MA0XX (hoja International PL Bags) o Expo MA0XX. La exportación sale del nombre del archivo; asignan sus Big Bags y traen el oro del documento.',
    'Packing lists: Calculos Expo concentrados MA0XX (International PL Bags sheet) or Expo MA0XX. The export comes from the file name; they assign its Big Bags and bring the document gold.',
  ),
  archivoDeclaraciones: txt(
    'PDF de las declaraciones de valor de las recolecciones (TM): por Big Bag traen sello, pesos, tenores, onzas y valor en USD. El número de la TM sale del nombre del archivo. Si no se eligen, se conservan las ya cargadas.',
    'Value declaration PDFs of the pickups (TM): per Big Bag they bring seal, weights, grades, ounces and USD value. The TM number comes from the file name. If none are chosen, those already loaded are kept.',
  ),
  archivoSoloDeclaraciones: txt(
    'PDF de las declaraciones de valor (TM). El número de la TM sale del nombre del archivo; la fecha, los Big Bags, pesos y valores, del PDF. Una TM que ya estaba se reemplaza.',
    'Value declaration PDFs (TM). The TM number comes from the file name; the date, Big Bags, weights and values, from the PDF. A TM already loaded is replaced.',
  ),

  // ── Resultado de las declaraciones ──
  tmCodigo: txt('Número de la recolección, tomado del nombre del archivo.', 'Pickup number, taken from the file name.'),
  tmFecha: txt(
    'Fecha de la declaración de valor, leída del PDF. Desde ese día sus Big Bags cuentan en la bodega.',
    'Date of the value declaration, read from the PDF. From that day its Big Bags count in the warehouse.',
  ),
  tmBigBags: txt('Big Bags que trae la declaración.', 'Big Bags listed in the declaration.'),
  tmHumedo: txt(
    'Suma del peso húmedo declarado de sus Big Bags, en kilos.',
    'Sum of the declared wet weight of its Big Bags, in kilos.',
  ),
  tmValor: txt('Suma del valor declarado en USD de sus Big Bags.', 'Sum of the declared USD value of its Big Bags.'),
  tmABodega: txt(
    'Big Bags que estaban en la planta y pasan a la bodega de Cartagena con esta TM.',
    'Big Bags that were at the plant and move to the Cartagena warehouse with this TM.',
  ),
  tmNovedad: txt(
    'Si la TM es nueva o reemplaza una ya cargada, y cuántos de sus Big Bags no están en el inventario de Mineros (entran con el archivo de la planta).',
    'Whether the TM is new or replaces one already loaded, and how many of its Big Bags are not in the Mineros inventory (they come in with the plant file).',
  ),
};
